import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import Discontinued from "./pages/Discontinued";

// InstantVAT has been discontinued. Every route serves the notice page.
const App = () => (
  <ErrorBoundary>
    <BrowserRouter>
      <Routes>
        <Route path="*" element={<Discontinued />} />
      </Routes>
    </BrowserRouter>
  </ErrorBoundary>
);

export default App;
